import { AGGREGATE_NAMES, USER_RESOLVERS } from 'cpool-constants';
import { schemaUserResolver_GetAdvisersByRole } from 'cpool-tables/backend-resolvers';
import { getActiveOrFirstUserId } from 'cpool-utils';

import { useAggregateQuery } from '~/queryUtils/useQuery';

// same query key as useAdviserAssign for the same lead: deduped where both are mounted
export const useLeadAdvisers = ({ activeUserId, userIds }: { activeUserId?: string | null; userIds: string[] }) =>
    useAggregateQuery({
        acl: { userId: getActiveOrFirstUserId({ activeUserId, userIds }) ?? undefined },
        aggregateName: AGGREGATE_NAMES.USER,
        resolverName: USER_RESOLVERS.getAdvisersByRole,
        schema: schemaUserResolver_GetAdvisersByRole,
        searchParams: { ...(userIds.length ? { leadUserIds: userIds } : {}), position: undefined },
    });
